import { t } from "@/lib/i18n";
import { useState } from "react";
import { Loader2, SearchX } from "lucide-react";
import { OfficeCard } from "./OfficeCard";

const PAGE = 12;

export const Directory = ({ offices, loadingNearby, place, onAskAI, onFocus, onHover, hoverId }) => {
  const [limit, setLimit] = useState(PAGE);
  return (
    <div>
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2 text-xs text-ac-muted">
        <p data-testid="directory-count">
          <span className="font-mono font-semibold text-ac-ink">{offices.length}</span> {t("dir.results", { place })}
        </p>
        {loadingNearby && (
          <span data-testid="nearby-loading" className="flex items-center gap-1.5 text-ac-primary-ink">
            <Loader2 className="h-3.5 w-3.5 animate-spin" /> {t("dir.scanning")}
          </span>
        )}
      </div>
      {offices.length === 0 ? (
        <div data-testid="directory-empty" className="grid place-items-center rounded-2xl border border-dashed border-ac-line2 bg-ac-surface py-14 text-center">
          <SearchX className="h-8 w-8 text-ac-faint" />
          <p className="mt-3 font-medium text-ac-text">{t("dir.emptyT")}</p>
          <p className="text-sm text-ac-muted">{t("dir.emptyS")}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {offices.slice(0, limit).map((o, i) => (
            <OfficeCard key={o.id} office={o} index={i} onAskAI={onAskAI} onFocus={onFocus} onHover={onHover} active={o.id === hoverId} />
          ))}
        </div>
      )}
      {offices.length > limit && (
        <button data-testid="directory-load-more" onClick={() => setLimit(limit + PAGE)} className="mx-auto mt-4 block rounded-full border border-ac-line2 bg-ac-surface px-5 py-2 text-sm font-semibold text-ac-ink transition-colors hover:bg-ac-surface2">
          {t("dir.more", { n: offices.length - limit })}
        </button>
      )}
    </div>
  );
};
